<template>
  <b-container fluid="true" style="margin-left: 0px; width: 100%; border-radius: 30px;">
    <loading :active.sync="isLoading"
             :can-cancel="false"
             :is-full-page="fullPage"
             :opacity=".97"
             :before="true">
      <template v-slot:before><h3>Loading ...</h3></template>
    </loading>
    <div class="container-fluid">
      <b-row style="margin: 5px; text-align: center; width: 100%">
        <b-col sm="2">

        </b-col>
        <b-col sm="8">
          <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Checklist Type:"
                        label-for="listType-select">
            <b-form-select id="listType-select" v-model="listType" :options="listTypeChoices"></b-form-select>
          </b-form-group>
          <div hidden v-if="true" style="text-align: center">
            Current Winery: Some Winery
          </div>
          <p/>
          <div hidden style="text-align: center">
            Checklist Status: IN PROGRESS
          </div>
          <div style="text-align: center; margin: 5px;" v-if="false">
            <b-button @click="doPdf" id="pdfButton" variant="success">Save PDF</b-button>
          </div>
        </b-col>
        <b-col sm="2">
        </b-col>
      </b-row>
      <b-row align-h="center" no-gutters id="pdfContent">
        <b-col sm="3" class="no-gutters">
          <b-container fluid style="border-radius: 15px;  padding: 10px 0; background-color:rgb(248, 248, 248)">
            <ul v-bind="surveys" class="survey-tabs">

              <li v-for="value in  surveys.items" :key="value.id">
                <VineyardMenuItemV2 :ref=refName(value.id) :section="value.name" :value="value" :key="value.id"
                                    surveyKey="12345678990" :topLevelParent="[value.name]"></VineyardMenuItemV2>
              </li>
            </ul>
          </b-container>
        </b-col>
        <b-col sm="9" style="padding-left: 5px;">
          <vineyard-survey-page-editor :page-id="pageId" :answers="answers"/>
        </b-col>
      </b-row>
      <b-row align-h="center" no-gutters>
        <b-col sm="3" style="border-radius: 15px;  padding: 10px 0;">
        </b-col>
        <b-col sm="8" class="no-gutters" style="margin-left:5px; padding-left: 5px; background-color: lightgray">
          <b-container style="text-align: left">
            <span class="nav-text" @click="previousPage">
              Previous
            </span>
            <span class="nav-text" @click="nextPage">
              Next
            </span>
          </b-container>
        </b-col>
      </b-row>
      <b-row style="padding-top: 10px">
        <b-col sm="4"></b-col>
        <b-col sm="8">
          <b-container fluid style="text-align: center; margin-top: 5px; margin-bottom: 10px">
            <b-button @click="saveSurvey" style="background-color: green; width:65%">
              SAVE
            </b-button>
          </b-container>
        </b-col>
      </b-row>
    </div>
    <b-modal id="modal-1" title="Resolve Conflicts" effect="fade/zoom" hide-footer size="xl">
      <div>
        <p class="my-4">Resolving {{ currentResolutionNumber }} of {{
            Object.getOwnPropertyNames(resolutionMap).length - 1
          }} Conflicts</p>
        <hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">
        <b-form-group label="Responses">
          <b-form-radio v-model="selectedResponse" name="some-radios" :value="theirResponse">Their
            Response: {{ theirResponse }}
          </b-form-radio>
          <b-form-radio v-model="selectedResponse" name="some-radios" :value="myResponse">My Response: {{
              myResponse
            }}
          </b-form-radio>
        </b-form-group>

        <div slot="modal-footer" class="modal-footer">
          <button type="button" class="btn btn-success" @click.prevent="nextAction" :disabled="canNext">
            Next
          </button>
          <button type="button" class="btn btn-success" @click.prevent="saveAction" :disabled="canSave">
            Save
          </button>
          <button type="button" class="btn btn-default" @click.prevent="cancelAction">Cancel</button>
        </div>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import html2canvas from "html2canvas";
import VineyardMenuItemV2 from "@/components/vineyard/VineyardMenuItemV2";
import Bus from "@/eventBus";
import Swal from "sweetalert2";
import VineyardSurveyPageEditor from "@/components/vineyard/editor/VineyardSurveyPageEditor";
import Loading from "vue-loading-overlay";

Array.prototype.groupBy = function (prop) {
  return this.reduce(function (groups, item) {
    const val = item[prop];
    groups[val] = groups[val] || [];
    groups[val].push(item);
    return groups
  }, {})
}
export default {
  name: "VineyardPageEditor",
  components: {
    VineyardSurveyPageEditor,
    VineyardMenuItemV2,
    Loading
  },
  props: {
    checklistType: String
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      id: "",
      surveyKey: "",
      creatorId: "creatorId",
      creationDate: new Date().getTime(),
      lastUpdated: new Date().getTime(),
      certificationPeriodStart: new Date().getTime(),
      certificationPeriodEnd: new Date().getTime(),
      actualCertificationDate: new Date().getTime(),
      status: "",
      version: "",
      lastUpdatedBy: "",
      responsesMap: {},
      groupId: "5dda0499177d91260f73f33d",
      surveyType: "INITIAL",
      answers: {},
      surveys: {},
      editMode: true,
      pageId: '',
      // Data required for conflict resolution.
      currentResolutionQuestion: "",
      currentResolutionNumber: 1,
      theirResponse: '',
      myResponse: '',
      selectedResponse: '',
      //checkboxMine: '',
      //checkboxTheirs: '',
      //patchMap: {},
      resolutionMap: {},
      modalSaveDisabled: true,
      nextButtonDisabled: false,
      patchResponseMap: new Map(),
      checklistMeta: {},
      listType: this.$route.query.checklistType,
      listTypeChoices: ['WINE', 'VINEYARD']
    }
  },
  created() {
    Bus.$on('vineyard-page-update', this.changeVineyardSurveyPage);
    Bus.$on('measure-answer-update', this.updateAnswer);
  },
  beforeDestroy() {
    Bus.$off('vineyard-pageUpdate', this.changeVineyardSurveyPage);
    Bus.$off('measure-answer-update', this.updateAnswer);
  },
  methods: {
    saveCheckBoxAsString: function (responseData) {
      Object.entries(responseData).map((value, key) => {
        if (Array.isArray(value[1])) {
          responseData[value[0]] = JSON.stringify(value[1]);
        }
      })
      return responseData;
    },
    unwindJsonToCheckBox: function (responseData) {
      Object.entries(responseData).map((value, key) => {
        if (typeof value[1] === "string" && value[1].startsWith("[") && value[1].endsWith("]")) {
          let valueObject = JSON.parse(value[1]);
          console.log("Parsed Value Object");
          console.log(valueObject)
          responseData[value[0]] = valueObject;
        }
      });
      return responseData;
    },
    nextAction: function () {
      if (this.selectedResponse === '') {
        return;
      }
      this.patchResponseMap.set(this.currentResolutionQuestion, this.selectedResponse);

      let currentResolutionQuestionIndex = Object.keys(this.resolutionMap).findIndex((element) => {
        return element === this.currentResolutionQuestion
      });
      this.currentResolutionQuestion = Object.keys(this.resolutionMap)[currentResolutionQuestionIndex + 1];
      ++this.currentResolutionNumber;
      //this.currentResolutionQuestion = Object.keys(this.resolutionMap).find()[++this.currentResolutionNumber];
      this.theirResponse = this.getResponseOrUnanswered(this.resolutionMap[this.currentResolutionQuestion][0]);
      this.myResponse = this.getResponseOrUnanswered(this.resolutionMap[this.currentResolutionQuestion][1]);
      if (Object.getOwnPropertyNames(this.resolutionMap).length === this.currentResolutionNumber) {
        this.modalSaveDisabled = false;
        this.nextButtonDisabled = true;
      }
    },
    cancelAction: function () {
      this.$bvModal.hide("modal-1");
    },
    saveAction: function () {
      this.patchResponseMap.set(this.currentResolutionQuestion, this.selectedResponse);
      let self = this;

      let patchResponseList = {};
      this.patchResponseMap.forEach((value, key) => {
        patchResponseList[key] = value;
      });

      let surveyResponse = {
        _id: self.surveyResponseId,
        surveyKey: self.survey.surveyKey,
        responsesMap: self.patchResponseMap,
        lastUpdated: self.lastUpdatedDate,
        lastUpdatedBy: localStorage.getItem('user'),
        patchResponseMap: patchResponseList,
        groupId: self.myGroupId
      };
      this.$http.patch("survey", surveyResponse, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(returnVal => {
            if (returnVal.data.saved === true) {
              Swal.fire({
                title: 'Survey Saved',
                text: 'Your Survey Has Been Save Successfully.',
                icon: 'success'
              });
              this.loadSurvey();
              this.patchResponseMap = new Map();
              this.currentResolutionQuestion = '';
              this.currentResolutionNumber = 1;
            } else {
              Swal.fire({
                title: 'Survey Save Failed',
                text: 'There was an error while saving.',
                icon: 'error'
              });
            }

          }).catch(error => {
        Swal.fire({
          title: 'Survey Save Failed',
          text: `There was an error while saving. Error: ${error.message}`,
          icon: 'error'
        });
      });
      this.$bvModal.hide("modal-1");
    },
    toSurveyResponse: function () {
      let responseObject = this.saveCheckBoxAsString(this.answers);
      let certificationPeriodStart = this.certificationPeriodStart;
      let response = {
        _id: this.id,
        surveyKey: this.surveyKey,
        creatorId: this.creatorId,
        creationDate: this.creationDate,
        lastUpdated: new Date().getTime(),
        certificationPeriodStart: certificationPeriodStart,
        certificationPeriodEnd: this.certificationPeriodEnd,
        actualCertificationDate: this.actualCertificationDate,
        status: "IN_PROGRESS", //this.status,
        version: this.version,
        lastUpdatedBy: localStorage.getItem("userId"),
        responsesMap: responseObject,
        groupId: this.groupId,
        surveyType: this.surveyType
      };
      return response;
    },
    changeVineyardSurveyPage: function (newPageId) {
      this.pageId = newPageId;
    },
    updateAnswer: function (questionId, value) {
      this.answers[questionId] = value;
    },
    refName: function (name) {
      return 'poo' + name;
    },
    doPdf: function () {
      let pdfMake = require("pdfmake/build/pdfmake");
      html2canvas(document.getElementById("pdfQuestions"))
          .then(function (canvas) {
            let html = canvas.toDataURL();
            let content = {content: [{image: html, width: 500}]};
            console.log(content);
            pdfMake.createPdf(content).download('sample.pdf');
          });
    },
    getResponseOrUnanswered: function (response) {
      return (response === '' || response === null) ? "Unanswered" : response;
    },
    saveSurvey: function () {
      this.$toasted.info("Survey Saved!!", {
        containerClass: 'super-toasty',
        iconPack: 'fontawesome',
        closeOnSwipe: true,
        action: {
          text: 'DISMISS',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          }
        }
        , icon: {
          name: 'fa-save',
          after: false
        }
      })
          .goAway(5000);
      let response = this.toSurveyResponse();
      let surveyJson = JSON.stringify(response, null, 3);
      this.$http.post(`vineyard`, surveyJson, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(result => {
            if (response.status === 202) {
              if (response.data.saved) {
                self.lastUpdatedDate = response.data.lastUpdatedDate;
                this.$toasted.info("Checklist Saved Successfully", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-save',
                    after: false
                  }
                })
                    .goAway(5000);
              } else {

                self.resolutionMap = response.data.differenceMap;
                self.currentResolutionQuestion = Object.keys(self.resolutionMap)[0];
                self.theirResponse = this.getResponseOrUnanswered(self.resolutionMap[self.currentResolutionQuestion][0]);
                self.myResponse = this.getResponseOrUnanswered(self.resolutionMap[self.currentResolutionQuestion][1]);
                self.currentResolutionNumber = 1;
                this.$bvModal.show("modal-1");
              }

            }
          }).catch(
          error => {
            console.log(error)
          });
    },
    nextPage: function () {
      console.log("Next Page");
      let pages = this.checklistMeta.pages;
      let currentPageIndex = pages.indexOf(this.pageId);
      console.log("Current Index: " + currentPageIndex + " Size of Array: " + pages.length);
      if (currentPageIndex < (pages.length - 1)) {
        this.pageId = pages[currentPageIndex + 1];
      }
    },
    previousPage: function () {
      console.log("Previous Page");
      let pages = this.checklistMeta.pages;
      let currentPageIndex = pages.indexOf(this.pageId);
      console.log("Current Index: " + currentPageIndex + " Size of Array: " + pages.length);
      if (currentPageIndex > 0) {
        this.pageId = pages[currentPageIndex - 1];
      }
    },
    loadMenuAndChecklist: function () {
      let self = this;
      this.$http.get(`vineyard/menu/type/${this.listType}`)
          .then(result => {
            self.surveys = result.data;
          }).catch(
          error => {
            console.log(error)
          });

      this.$http.get(`vineyard/survey/checklist/type/${this.listType}`)
          .then(result => {
            self.checklistMeta = result.data;
            self.pageId = self.checklistMeta.pages[0]
            self.isLoading = false;
          }).catch(
          error => {
            console.log(error)
          });
    }
  },
  computed: {
    canEdit: function () {
      return this.editMode;
    },
    canSave() {
      return this.modalSaveDisabled && this.selectedResponse === '';
    },
    canNext() {
      return (Object.getOwnPropertyNames(this.resolutionMap).length - 1) === this.currentResolutionNumber;
    },
  },
  mounted() {
    let self = this;
    self.isLoading = true;
    let groupId = localStorage.getItem('groupId');
    let url;
    if (self.isAdmin || self.isCertifier) {
      if (!self.surveyResponseId) {
        Swal.fire({
          title: 'Select A Survey',
          text: 'Please Select a Winery to Continue.',
          icon: 'question'
        });
        this.$router.push("/questionnaire-admin");
        return;
      }
      url = "vineyard/response/id/" + self.surveyResponseId;
    } else {
      //url = "vineyard/response/" + self.myGroupId;
      url = "vineyard/response/" + self.groupId;
    }
    // This should happen first
    this.$http.get(url)
        .then(result => {
          this.surveyData = result.data;
          self.id = result.data._id;
          self.lastUpdatedDate = result.data.lastUpdated;
          self.responsesMap = self.unwindJsonToCheckBox(result.data.responsesMap);
          self.answers = self.unwindJsonToCheckBox(result.data.responsesMap);
          self.certificationPeriodStart = self.surveyData.certificationPeriodStart;
          self.certificationPeriodEnd = self.surveyData.certificationPeriodEnd;
          self.surveyKey = result.data.surveyKey;
          self.creationDate = self.surveyData.creationDate;
          self.creatorId = self.surveyData.creatorId;
          self.status = self.surveyData.status;
          self.surveyType = self.surveyData.surveyType;
          self.lastUpdatedBy = self.surveyData.lastUpdatedBy;
          self.actualCertificationDate = self.surveyData.actualCertificationDate;
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            title: 'Error Loading Survey',
            text: `Could not load survey with error: ${err.message}`,
            icon: 'error'
          });
        })
    // Menu Pull
    this.$http.get(`vineyard/menu/type/${this.listType}`)
        .then(result => {
          self.surveys = result.data;
        }).catch(
        error => {
          console.log(error)
        });

    this.$http.get(`vineyard/survey/checklist/type/${this.listType}`)
        .then(result => {
          self.checklistMeta = result.data;
          self.pageId = self.checklistMeta.pages[0]
          self.isLoading = false;
        }).catch(
        error => {
          console.log(error)
        });
  },
  watch: {
    listType: function (type) {
      this.loadMenuAndChecklist();
    }
  }
}


</script>
<style>

.nav-text {
  font-size: 20px;
  margin: 10px;
  color: black;
  cursor: pointer;
}

</style>

